export { default } from './VoterHistoryTableContainer';
